import toast from 'react-hot-toast';
import { callService } from '../services/callService';
import { leadService } from '../services/leadService';
import { classifyRecordingFetchError, recordingErrorCopy } from './recordingErrors';

function safeFilename(base: string): string {
  const trimmed = base.trim().replace(/[^a-z0-9-_]+/gi, '-').replace(/-+/g, '-');
  return trimmed || 'call-recording';
}

export async function downloadCallRecording(
  callAttemptId: string,
  filenameBase?: string
): Promise<void> {
  try {
    await callService.downloadCallRecording(callAttemptId, filenameBase);
    toast.success('Recording download started');
  } catch (error) {
    const classified = await classifyRecordingFetchError(error);
    const copy = recordingErrorCopy(classified.kind);
    toast.error(copy.title);
  }
}

export async function downloadLatestLeadRecording(
  leadId: string,
  filenameBase?: string
): Promise<void> {
  try {
    const attempts = await leadService.getCallAttempts(leadId);
    if (!attempts.length) {
      toast.error('No calls found for this lead');
      return;
    }
    await downloadCallRecording(attempts[0].id, filenameBase);
  } catch (error) {
    console.error('Failed to download latest recording:', error);
    toast.error('Could not download recording');
  }
}

export { safeFilename };
